import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";

import { Tooltip, Button } from "@mantine/core";

import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const { REACT_APP_ECLIPSE_API, REACT_APP_ECLIPSE_API_LOCAL } = process.env;

const Chart_Bar_CafePOS_HeatMap_HourlyADay = ({
  dateSelected,
  cafeSelected,
  pcSelected,
  pczoneSelected,
  pcRemarkSelected,
}) => {
  const [DB_CafePC_ByCafe, setDB_CafePC_ByCafe] = useState([]);
  const get_DB_CafePC_ByDateCafePC = async (_date_1day, _cafe, _pc) => {
    setLoading(true);
    await axios
      //REACT_APP_ECLIPSE_API
      .post(
        `${REACT_APP_ECLIPSE_API}/get_awesome_pos__pcdata_hourly_in_a_day__bydate_cafe_pc`,
        {
          date_1day: _date_1day,
          cafe: _cafe,
          pc: _pc,
        }
      )
      .then((res) => {
        // console.log("get_DB_CafePC_ByDateCafePC", res?.data);

        setDB_CafePC_ByCafe(res?.data);
        setLoading(false);
      });
  };

  // Filter ranges that belong to the selected date
  const filteredRanges = DB_CafePC_ByCafe?.filter(
    (range) =>
      dayjs(range.dlsj).format("YYYY-MM-DD") === dateSelected ||
      dayjs(range.jssj).format("YYYY-MM-DD") === dateSelected
  );

  // Convert ranges into dayjs
  const parsedRanges = filteredRanges?.map((range) => ({
    start: dayjs(range.dlsj),
    end: dayjs(range.jssj),
  }));

  // Generate time blocks every 15 minutes
  const timeBlocks = [];
  const startTime = dayjs(`${dateSelected} 00:00`);
  for (let i = 0; i < 96; i++) {
    const time = startTime.add(i * 15, "minute");
    timeBlocks.push(time);
  }

  // Check if a time block falls within any of the ranges
  const isInRange = (blockTime) => {
    return parsedRanges.some(({ start, end }) => {
      return blockTime.isSameOrAfter(start) && blockTime.isSameOrBefore(end);
    });
  };

  //------------------------------------- global variable
  const [loading, setLoading] = useState(false);

  //------------------------------------- func

  function stringToColor(str) {
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) + hash + str.charCodeAt(i); // djb2 hash
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
      // Force the value to be in the lower half (darker) of the color spectrum
      const value = Math.abs((hash >> (i * 8)) & 0xff) >> 1; // divide by 2 to keep it dark
      color += value.toString(16).padStart(2, "0");
    }
    return color;
  }

  // Helper to get duration in ?day ?hour ?min ?sec format
  function getDurationDHMS(start, end) {
    const totalSeconds = dayjs(end).diff(dayjs(start), "second");
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  }

  // Update ExampleSessionList to use the new format
  function ExampleSessionList({ data }) {
    // Calculate total usage in seconds
    const totalSeconds = data.reduce(
      (sum, item) => sum + dayjs(item.jssj).diff(dayjs(item.dlsj), "second"),
      0
    );
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const totalUsageStr = `${days}d ${hours}h ${minutes}m ${seconds}s`;

    return (
      <div>
        <h3>Session List</h3>
        <table border="1" cellPadding={4} style={{ fontSize: 12 }}>
          <thead>
            <tr>
              <th>#</th>
              <th>Start (dlsj)</th>
              <th>End (jssj)</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{item.dlsj}</td>
                <td>{item.jssj}</td>
                <td>{getDurationDHMS(item.dlsj, item.jssj)}</td>
              </tr>
            ))}
            {/* Summary row */}
            <tr>
              <td
                colSpan={3}
                style={{ fontWeight: "bold", textAlign: "right" }}
              >
                Total Usage
              </td>
              <td style={{ fontWeight: "bold" }}>{totalUsageStr}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  const Custom_Margin = (_time) => {
    let result = null;
    if (_time == "06:00" || _time == "12:00" || _time == "18:00") {
      result = "0.5rem";
    } else {
      result = "0.1rem";
    }

    return result;
  };

  useEffect(() => {
    // console.log("CafePOST DB_CafePC_ByCafe:", DB_CafePC_ByCafe);
    // console.log("CafePOST dateSelected:", dateSelected);
  }, []);

  useEffect(() => {
    get_DB_CafePC_ByDateCafePC(dateSelected, cafeSelected, pcSelected);
  }, [dateSelected, cafeSelected, pcSelected]);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",

          backgroundColor: stringToColor(pczoneSelected),
          gap: 10,
          border: "2px solid transparent",
        }}
        className="CM_Cell_Style1"
      >
        <div
          style={{
            width: "80px",
            minWidth: "80px",
            fontSize: 10,
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            marginLeft: 10,
          }}
        >
          {/* <div>{`🎮${DB_CafePC_ByCafe?.length}`}</div> */}
          <Tooltip
            label={
              <>
                <ExampleSessionList data={DB_CafePC_ByCafe} />
              </>
            }
          >
            <div>🔍{pczoneSelected}</div>
          </Tooltip>
        </div>
        <div
          style={{
            width: "120px",
            minWidth: "120px",
            fontSize: 15,
            textAlign: "right",
          }}
          className="CM_Flex_Row"
        >
          <div>{pcSelected}</div>
          <div
            style={{
              color: "lime",
              backgroundColor: "black",
              paddingLeft: "0.5rem",
              paddingRight: "0.5rem",
              marginLeft: "0.5rem",
            }}
          >
            {pcRemarkSelected ?? "" ? ` - ${pcRemarkSelected}` : ""}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: 0,
            width: "1400px",
            minWidth: "1400px",
          }}
        >
          {timeBlocks?.map((time, idx) => {
            const isGreen = isInRange(time);
            return (
              <div
                key={idx}
                style={{
                  width: 13, // narrower, since height will be more
                  height: 20, // taller to accommodate rotated text
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: loading
                    ? ""
                    : isGreen
                    ? "linear-gradient(to right, #ee0979, #ff6a00)"
                    : "#eee",
                  color: isGreen ? "white" : "black",
                  borderRadius: 0,
                  fontSize: 10,
                  writingMode: "vertical-rl",
                  transform: "rotate(180deg)",
                  whiteSpace: "nowrap",
                  marginBottom: "0.1rem",
                  marginLeft: Custom_Margin(time.format("HH:mm")),
                }}
              >
                .{/* {time.format("HH:mm")} */}
                {/* {time.format("HH")} */}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Chart_Bar_CafePOS_HeatMap_HourlyADay;
